import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=77ab43f2&"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js&"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports